import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { FuseConfigService } from '../../core/services/config.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../core/services/auth.service';

@Component({
    selector   : 'fuse-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls  : ['./toolbar.component.scss']
})

export class FuseToolbarComponent implements OnInit
{
    userStatusOptions: any[];
    languages: any;
    selectedLanguage: any;
    showLoadingBar: boolean;
    horizontalNav: boolean;
    accountData: any;
    fullscreen = false;

    constructor(
        public authService: AuthService,
        private router: Router,
        private fuseConfig: FuseConfigService,
        private translate: TranslateService
    ) {
        /*
        this.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        */

        this.languages = [
            {
                'id'   : 'fr',
                'fitle': 'Français',
                'flag' : 'fr'
            },
            {
                'id'   : 'en',
                'title': 'English',
                'flag' : 'us'
            },
        ];

        this.selectedLanguage = this.languages[0];

        router.events.subscribe(
            (event) => {
                if ( event instanceof NavigationStart )
                {
                    this.showLoadingBar = true;
                }
                if ( event instanceof NavigationEnd )
                {
                    this.showLoadingBar = false;
                }
            });

        this.fuseConfig.onSettingsChanged.subscribe((settings) => {
            this.horizontalNav = settings.layout.navigation === 'top';
        });

    }

    ngOnInit() {
        this.accountData = this.authService.payload;
    }

    search(value)
    {
        // Do your search here...
        // console.log(value);
    }

    setLanguage(lang)
    {
        // Set the selected language for toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this.translate.use(lang.id);
    }

    toggleFullScreen() {
        if (!document.fullscreenElement) {
            this.fullscreen = true;
            document.documentElement.requestFullscreen();
        } else {
            if (document.exitFullscreen) {
                this.fullscreen = false;
                document.exitFullscreen();
            }
        }
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/main/toolbar/toolbar.component.ts